module.exports = __webpack_public_path__ + "img/whatap_logo.6ee56736.png";